import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getLargestFloatChanges';

export const getLargestFloatChanges = (params) => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
